import viewportHelper from '@kissui/helpers/src/viewport.helpers'
import { VARIATION_PDP, VARIATION_PLP } from '@kissui/components/src/sku/constants'
import { ECAPI_TYPE_CAPSULE } from '@kissui/helpers/src/catalog'

export const setCardTheme = ({ variation, type }, component) => {
    // PDP
    if (variation === VARIATION_PDP) {
        component.setAttribute('pdp', 'true') // Used by CSS to increase font-size, etc.
    }

    // COFFEE on PLP on MOBILE
    if (variation === VARIATION_PLP && type === ECAPI_TYPE_CAPSULE && viewportHelper.is.mobile) {
        component.setAttribute('landscape', 'true')
        return
    }

    component.setAttribute('portrait', 'true')
}
